import script from "./SensitiveContentWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./SensitiveContentWarning.vue?vue&type=script&setup=true&lang=js"

import "./SensitiveContentWarning.vue?vue&type=style&index=0&id=9b7b2f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b7b2f2c"]])

export default __exports__